"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastSessionResponseTodaySummaryToJSON = exports.LastSessionResponseTodaySummaryFromJSONTyped = exports.LastSessionResponseTodaySummaryFromJSON = void 0;
var runtime_1 = require("../runtime");
function LastSessionResponseTodaySummaryFromJSON(json) {
    return LastSessionResponseTodaySummaryFromJSONTyped(json, false);
}
exports.LastSessionResponseTodaySummaryFromJSON = LastSessionResponseTodaySummaryFromJSON;
function LastSessionResponseTodaySummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalXP': !(0, runtime_1.exists)(json, 'totalXP') ? undefined : json['totalXP'],
        'totalTime': !(0, runtime_1.exists)(json, 'totalTime') ? undefined : json['totalTime'],
        'uniqueGames': !(0, runtime_1.exists)(json, 'uniqueGames') ? undefined : json['uniqueGames'],
    };
}
exports.LastSessionResponseTodaySummaryFromJSONTyped = LastSessionResponseTodaySummaryFromJSONTyped;
function LastSessionResponseTodaySummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totalXP': value.totalXP,
        'totalTime': value.totalTime,
        'uniqueGames': value.uniqueGames,
    };
}
exports.LastSessionResponseTodaySummaryToJSON = LastSessionResponseTodaySummaryToJSON;
